import React from 'react';
import { secondsToDate } from './helpers';
export const Timer = ({ timeLeft }) => React.createElement("span", { role: "timer" }, secondsToDate(timeLeft));
//# sourceMappingURL=index.js.map